<app-header></app-header>
<ion-content
  data-cy="support-center-content"
  class="gray-content-bg"
  scroll-y="false"
>
  <div
    *ngIf="(viewModel$ | async) as viewModel"
    class="scroll-container"
    data-cy="scroll-container"
    cdkVirtualScrollingElement
  >
    <!-- Desktop Page Header -->
    <div data-cy="support-center-header" class="support-center-header">
      <ion-grid
        [fixed]="true"
        [class.touch]="(platformService?.isTouchExperience$ | async)"
      >
        <!-- Breadcrumbs -->
        <ion-row
          *ngIf="(platformService?.isTouchExperience$ | async) === false"
          data-cy="support-center-breadcrumbs-row"
          class="support-center-breadcrumbs"
        >
          <ion-col data-cy="support-center-breadcrumbs-column" size="12">
            <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
          </ion-col>
        </ion-row>
        <!-- Page Title -->
        <ion-row data-cy="support-center-page-title-row">
          <ion-col data-cy="support-center-page-title-row" size="12">
            <h2
              data-cy="support-center-page-title-text"
              class="support-center-title"
              [class.mobile-title]="platformService?.platformType === platformService?.platformEnum?.mobile"
            >
              {{ 'i18n.supportCenter.title' | translate | uppercase}}
            </h2>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="platformService?.platformType !== platformService?.platformEnum?.mobile"
          class="support-center-tiles ion-justify-content-between"
          data-cy="support-center-tiles"
        >
          <ion-col *ngIf="(supportRequestFlag$ | async)" size="3.85">
            <app-header-tile
              [dataCyTag]="'support-request'"
              [platformType]="platformService?.platformType"
              [headingText]="'i18n.supportCenter.request.support'"
              [subHeadingText]="'i18n.supportCenter.needAssistance'"
              (clickEvent)="showSupportRequestModal(true)"
            ></app-header-tile>
          </ion-col>

          <ion-col
            [size]="(supportRequestFlag$ | async) === false ? '5.85' : '3.85'"
          >
            <app-header-tile
              [dataCyTag]="'credit-request'"
              [platformType]="platformService?.platformType"
              [headingText]="'i18n.requestCredit.creditRequest'"
              [subHeadingText]="'i18n.supportCenter.selectDamagedItem'"
              (clickEvent)="goToCreditRequest()"
            ></app-header-tile>
          </ion-col>

          <ion-col
            [size]="(supportRequestFlag$ | async) === false ? '5.85' : '3.85'"
          >
            <app-header-tile
              [dataCyTag]="'support-center-help-center'"
              [platformType]="platformService?.platformType"
              [headingText]="'i18n.more.helpCenter'"
              [subHeadingText]="'i18n.supportCenter.needHelpWithMoxe'"
              (clickEvent)="goToHelpCenter()"
            ></app-header-tile>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
          class="support-center-tiles ion-justify-content-between"
        >
          <ion-col size="5.85" *ngIf="(supportRequestFlag$ | async)">
            <app-header-tile
              [dataCyTag]="'support-request'"
              [platformType]="platformService?.platformType"
              [headingText]="'i18n.supportCenter.request.support'"
              [subHeadingText]="'i18n.supportCenter.needAssistance'"
              (clickEvent)="showSupportRequestModal(true)"
            ></app-header-tile>
          </ion-col>
          <ion-col size="5.85">
            <app-header-tile
              [dataCyTag]="'credit-request'"
              [platformType]="platformService?.platformType"
              [headingText]="'i18n.requestCredit.creditRequest'"
              [subHeadingText]="'i18n.supportCenter.selectDamagedItem'"
              (clickEvent)="goToCreditRequest()"
            ></app-header-tile>
          </ion-col>
          <ion-col size="5.85" *ngIf="(supportRequestFlag$ | async) === false">
            <app-header-tile
              [dataCyTag]="'support-center-help-center'"
              [platformType]="platformService?.platformType"
              [headingText]="'i18n.more.helpCenter'"
              [subHeadingText]="'i18n.supportCenter.needHelpWithMoxe'"
              (clickEvent)="goToHelpCenter()"
            ></app-header-tile>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile && (supportRequestFlag$ | async)"
          class="support-center-tiles ion-justify-content-between"
        >
          <ion-col size="5.85">
            <app-header-tile
              [dataCyTag]="'support-center-help-center'"
              [platformType]="platformService?.platformType"
              [headingText]="'i18n.more.helpCenter'"
              [subHeadingText]="'i18n.supportCenter.needHelpWithMoxe'"
              (clickEvent)="goToHelpCenter()"
            ></app-header-tile>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="viewModel?.filterCounts.all > 0">
          <ng-container
            [ngTemplateOutlet]="filterTabs"
            [ngTemplateOutletContext]="{ viewModel: viewModel }"
          ></ng-container>
        </ion-row>
      </ion-grid>
    </div>
    <ng-container
      *ngIf="viewModel.supportItems.length <= 0"
      [ngTemplateOutlet]="noData"
    ></ng-container>
    <ion-grid
      data-cy="support-center-grid"
      class="support-center-grid"
      [fixed]="true"
    >
      <app-sortable-section-desktop-tablet
        *ngIf="platformService.platformType !== platformEnum.mobile && viewModel.supportItems.length > 0"
        [showTitle]="false"
        [sectionTitle]=""
        [sectionHeaders]="viewModel?.supportCenterSort.headers"
        [selectedHeader]="viewModel?.supportCenterSort.selectedHeader"
        [hasSectionData]="true"
        [noDataText]="'i18n.inventory.noInventoriesToShow' | translate"
        (updateSortEventEmitter)="updateSupportCenterSort($event)"
      ></app-sortable-section-desktop-tablet>
      <cdk-virtual-scroll-viewport
        data-cy="support-center-scroll"
        class="cdk-scroll"
        orientation="vertical"
        itemSize="{{ viewModel?.itemSize }}"
      >
        <app-support-center-card
          *cdkVirtualFor="let supportItem of viewModel.supportItems; let i = index; trackBy: trackItem"
          [supportItem]="supportItem"
          [platform]="platformService.platformType"
          [index]="i"
          (resubmitEvent)="handleResubmitRequest($event)"
          (cardClickEmitter)="showSupportCenterModal($event)"
        >
        </app-support-center-card>
      </cdk-virtual-scroll-viewport>
    </ion-grid>
    <app-footer></app-footer>
  </div>
</ion-content>

<ng-template #noData>
  <div data-cy="support-center-content" class="support-center-content">
    <ion-row class="support-center-empty-row">
      <img src="assets/icon/support-center-logo.svg" />
      <p class="mobile-width">
        {{ 'i18n.supportCenter.submittedRequestsDisplay' | translate }}
      </p>
      <ion-button
        data-cy="support-center-credit-request-button"
        class="usf-fill-green-button"
        (click)="goToCreditRequest()"
        [class.mobile-font]="platformService?.platformType === platformService?.platformEnum?.mobile"
      >
        {{ 'i18n.supportCenter.startCreditRequest' | translate }}
      </ion-button>
    </ion-row>
  </div>
</ng-template>

<ng-template #filterTabs let-viewModel="viewModel">
  <div class="tab-container">
    <!-- all tab -->
    <div
      data-cy="support-center-all-requests-tab"
      class="filter-tab"
      (click)="selectFilter(null, viewModel.tabsMap?.all)"
      [class.selected]="currentFilter === null"
      data-index="0"
    >
      <div data-cy="support-center-all-requests-text">
        {{ 'i18n.supportCenter.status.all' | translate }}
      </div>
      <ion-badge
        data-cy="support-center-all-requests-icon"
        mode="ios"
        class="request-count all"
      >
        {{ viewModel?.filterCounts.all }}
      </ion-badge>
    </div>
    <!-- failed tab -->
    <div
      *ngIf="viewModel.tabsMap?.failed >= 0"
      data-cy="support-center-failed-requests-tab"
      class="filter-tab"
      (click)="selectFilter(sousStatus.FAILED, viewModel.tabsMap.failed)"
      [class.selected]="currentFilter === sousStatus.FAILED"
      data-index="1"
    >
      <div data-cy="support-center-failed-requests-text">
        {{ 'i18n.supportCenter.status.fail' | translate }}
      </div>
      <ion-badge
        data-cy="support-center-all-requests-icon"
        mode="ios"
        class="request-count failed"
      >
        {{ viewModel?.filterCounts.failed }}
      </ion-badge>
    </div>
    <!-- new tab -->
    <div
      *ngIf="viewModel.tabsMap?.new >= 0"
      data-cy="support-center-new-requests-tab"
      class="filter-tab"
      (click)="selectFilter(sousStatus.NEW, viewModel.tabsMap.new)"
      [class.selected]="currentFilter === sousStatus.NEW"
      data-index="2"
    >
      <div data-cy="support-center-failed-requests-text">
        {{ 'i18n.supportCenter.status.new' | translate }}
      </div>
      <ion-badge
        data-cy="support-center-new-requests-icon"
        mode="ios"
        class="request-count yellow"
      >
        {{ viewModel?.filterCounts.new }}
      </ion-badge>
    </div>
    <!-- in progress tab -->
    <div
      *ngIf="viewModel.tabsMap?.inProgress >= 0"
      data-cy="support-center-in-progress-requests-tab"
      class="filter-tab"
      (click)="selectFilter(sousStatus.IN_PROGRESS, viewModel.tabsMap.inProgress)"
      [class.selected]="currentFilter === sousStatus.IN_PROGRESS"
      data-index="3"
    >
      <div data-cy="support-center-in-progress-requests-text" class="no-wrap">
        {{ 'i18n.supportCenter.status.inProgress' | translate }}
      </div>
      <ion-badge
        data-cy="support-center-in-progress-requests-icon"
        mode="ios"
        class="request-count yellow"
      >
        {{ viewModel?.filterCounts.inProgress }}
      </ion-badge>
    </div>
    <!-- Waiting for Approval tab -->
    <div
      *ngIf="viewModel.tabsMap?.waitingForApproval >= 0"
      data-cy="support-center-waiting-for-approval-requests-tab"
      class="filter-tab"
      (click)="selectFilter(sousStatus.CREATED, viewModel.tabsMap.waitingForApproval)"
      [class.selected]="currentFilter === sousStatus.CREATED"
      data-index="3"
    >
      <div
        data-cy="support-center-waiting-for-approval-requests-text"
        class="no-wrap"
      >
        {{ 'i18n.supportCenter.status.waitingForApproval' | translate }}
      </div>
      <ion-badge
        data-cy="support-center-waiting-for-approval-requests-icon"
        mode="ios"
        class="request-count yellow"
      >
        {{ viewModel?.filterCounts.waitingForApproval }}
      </ion-badge>
    </div>
    <!-- approved tab -->
    <div
      *ngIf="viewModel.tabsMap?.approved >= 0"
      data-cy="support-center-approved-requests-tab"
      class="filter-tab"
      (click)="selectFilter(sousStatus.APPROVED, viewModel.tabsMap.approved)"
      [class.selected]="currentFilter === sousStatus.APPROVED"
      data-index="4"
    >
      <div data-cy="support-center-approved-requests-text">
        {{ 'i18n.supportCenter.status.approve' | translate }}
      </div>
      <ion-badge
        data-cy="support-center-approved-requests-icon"
        mode="ios"
        class="request-count approved"
      >
        {{ viewModel?.filterCounts.approved }}
      </ion-badge>
    </div>
    <!-- closed tab -->
    <div
      *ngIf="viewModel.tabsMap?.closed >= 0"
      data-cy="support-center-closed-requests-tab"
      class="filter-tab"
      (click)="selectFilter(sousStatus.CLOSED, viewModel.tabsMap.closed)"
      [class.selected]="currentFilter === sousStatus.CLOSED"
      data-index="5"
    >
      <div data-cy="support-center-closed-requests-text">
        {{ 'i18n.supportCenter.status.close' | translate }}
      </div>
      <ion-badge
        data-cy="support-center-closed-requests-icon"
        mode="ios"
        class="request-count closed"
      >
        {{ viewModel?.filterCounts.closed }}
      </ion-badge>
    </div>
  </div>
</ng-template>

<ion-modal
  [ngClass]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 'ion-modal-touch' : 'modal-desktop-size-xl'"
  [initialBreakpoint]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 1 : undefined"
  [breakpoints]="platformService?.platformType !== platformService?.platformEnum?.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="supportRequestModalIsOpen$ | async"
  (ionModalDidDismiss)="showSupportRequestModal(false)"
>
  <ng-template>
    <app-support-request-modal
      class="ion-page"
      [platformType]="platformService?.platformType"
      [email]="userEmail$ | async"
      [issueOptions]="supportRequestIssues$ | async"
      [photoArray]="supportRequestPhotos$ | async"
      (dismissEvent)="showSupportRequestModal(false)"
      (photoAddEvent)="onAddPhoto()"
      (photoDeleteEvent)="onDeletePhoto($event)"
      (submitEvent)="submitSupportRequest($event)"
    >
    </app-support-request-modal>
  </ng-template>
</ion-modal>

<ion-modal
  [ngClass]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 'ion-modal-touch' : 'modal-desktop-size-md'"
  [initialBreakpoint]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 1 : undefined"
  [breakpoints]="platformService?.platformType !== platformService?.platformEnum?.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="(supportCenterModalOptions$ | async)?.isOpen"
  (ionModalDidDismiss)="closeSupportCenterModal()"
>
  <ng-template>
    <app-support-center-modal
      class="ion-page"
      [platformType]="platformService?.platformType"
      [supportItem]="(supportCenterModalOptions$ | async)?.supportItem"
    >
    </app-support-center-modal>
  </ng-template>
</ion-modal>
